import { render } from "./NotificationsMgt.vue?vue&type=template&id=7f47991e&scoped=true"
import script from "./NotificationsMgt.vue?vue&type=script&lang=js"
export * from "./NotificationsMgt.vue?vue&type=script&lang=js"

import "./NotificationsMgt.vue?vue&type=style&index=0&id=7f47991e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f47991e"]])

export default __exports__